'use client';

import { api } from '@/convex/_generated/api';
import { useUser } from '@clerk/nextjs';
import { useMutation } from 'convex/react';
import { useEffect } from 'react';
import { trackAffiliateSignup } from '@/lib/affonso';

export default function SyncUserWithConvex() {
  const { user } = useUser();
  const updateUser = useMutation(api.users.updateUser);
  const createUser = useMutation(api.users.createUser);

  useEffect(() => {
    if (!user) return;

    const syncUser = async () => {
      try {
        await updateUser({
          userId: user.id,
          name: `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim(),
          email:
            user.emailAddresses && user.emailAddresses.length > 0
              ? (user.emailAddresses[0]?.emailAddress ?? '')
              : '',
        });
      } catch (error: any) {
        // If user not found, create the user
        if (error?.message?.includes('User not found for update')) {
          await createUser({
            userId: user.id,
            name: `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim(),
            email:
              user.emailAddresses && user.emailAddresses.length > 0
                ? (user.emailAddresses[0]?.emailAddress ?? '')
                : '',
          });
        } else {
          console.error('Error syncing user:', error);
        }
      }

      // Track affiliate signup if user has an email
      if (user.emailAddresses && user.emailAddresses.length > 0) {
        await trackAffiliateSignup(user.emailAddresses[0].emailAddress);
      }
    };

    syncUser();
  }, [user, updateUser, createUser]);

  return null;
}
